/**
 * Routes starting with the word 'one' are not loading correctly in our CMS mock
 */
export var CheckoutRoutes;
(function (CheckoutRoutes) {
    CheckoutRoutes["INDEX"] = "/";
    CheckoutRoutes["NEXT_STEPS"] = "/next-steps";
    CheckoutRoutes["YOUR_DETAILS"] = "/your-details";
    CheckoutRoutes["FINANCE_INSURANCE"] = "/finance-insurance";
    CheckoutRoutes["FINANCE"] = "/finance";
    CheckoutRoutes["PAYMENT"] = "/payment";
    CheckoutRoutes["CONFIRMATION"] = "/confirmation";
    CheckoutRoutes["IDENTITY_VERIFICATION"] = "/identity-verification";
    CheckoutRoutes["DEALER"] = "/dealer";
    CheckoutRoutes["EXTRAS"] = "/extras";
    CheckoutRoutes["ONE_STEP"] = "/simple-checkout";
    CheckoutRoutes["ACCESS_DENIED"] = "/access-denied";
    CheckoutRoutes["DEAL_UNAVAILABLE"] = "/deal-unavailable";
})(CheckoutRoutes || (CheckoutRoutes = {}));
//# sourceMappingURL=CheckoutRoutes.js.map